import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

export function EmailConfirmDialog({ open, onOpenChange, title = "Send Email Notification", description, onConfirm, loading = false }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border sm:max-w-md" data-testid="email-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading">
            <Mail className="w-5 h-5 text-primary" />
            {title}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground text-sm">
            {description || "This action will send an email notification. Do you want to proceed?"}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={loading} data-testid="email-confirm-cancel-btn">
            Cancel
          </Button>
          <Button
            onClick={() => { onConfirm(); onOpenChange(false); }}
            disabled={loading}
            data-testid="email-confirm-send-btn"
          >
            {loading ? "Sending..." : "Send & Continue"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
